<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="appName">
        <el-input v-model="queryParams.appName" filterable placeholder="公众号名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="shortName">
        <el-input v-model="queryParams.shortName" filterable placeholder="商户简称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="mchId">
        <el-input v-model="queryParams.mchId" filterable placeholder="收款商户号" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="mchName">
        <el-input v-model="queryParams.mchName" filterable placeholder="商户公司名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable placeholder="是否轮询" @keyup.enter.native="search" clearable>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-s-operation" @click.native="accountDetails">收款账号详情</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border :span-method="cellMerge">
      <el-table-column prop="name" label="公众号名称" align="center"></el-table-column>
      <el-table-column prop="money" label="今日收款金额" align="center"></el-table-column>
      <el-table-column prop="monthMoney" label="当月收款金额" align="center"></el-table-column>
      <el-table-column prop="maxMoney" label="日最大收款金额" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.editShow">{{scope.row.maxMoney}}</span>
          <el-input v-if="!scope.row.editShow" v-model="scope.row.maxMoney" placeholder="请输入日最大收款金额"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="monthMaxMoney" label="月最大收款金额" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.editShow">{{scope.row.monthMaxMoney}}</span>
          <el-input v-if="!scope.row.editShow" v-model="scope.row.monthMaxMoney" placeholder="请输入月最大收款金额"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="effect" label="当前收款账号" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.effect"
            active-color="#13ce66"
            inactive-color="#DCDFE6"
            active-value="1"
            inactive-value="0"
            @change="alonerenewChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.editShow">{{scope.row.priority}}</span>
          <el-input v-if="!scope.row.editShow" v-model="scope.row.priority" placeholder="请输入优先级"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="收款商户名称" align="center"></el-table-column>
      <el-table-column prop="mchId" label="收款商户号" align="center"></el-table-column>
      <el-table-column prop="mchName" label="商户主体" align="center" width="260px"></el-table-column>
      <el-table-column prop="status" label="是否轮询" align="center">
        <template slot="header">
            <el-tooltip content="当前公众号支付时，是否参与轮询收款" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
            是否轮询
        </template>
        <template slot-scope="{row}">
          <el-switch
            v-model="row.status"
            active-color="#13ce66"
            inactive-color="#C0CCDA"
            active-value="1"
            inactive-value="0"
            @change="handleStatusChange(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="editRow(scope.row)" v-if="scope.row.editShow">编辑</el-button>
          <el-button size="mini" type="success" plain icon="el-icon-edit" @click="preservation(scope.row)" v-if="!scope.row.editShow" >保存</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { dictionaryPayList } from "@/api/api.js";
import { dictionaryPayUpdate , dictionaryPayUpdateWxPayStatus } from "@/api/api.js";
export default {
  data() {
    return{
      tableData:[],
      rowIndex: '-1',
      OrderIndexArr: [],
      spanArr:[],
      pos:0,
      queryParams: {
        appName: undefined,
        shortName: undefined,
        mchName: undefined,
        mchId: undefined,
        status: undefined,
      },
    }
  },
  methods: {
    // 搜索
    search(){
      this.initData();
    },
    // 重置
    resetQuery(){
      this.resetForm("queryForm");
      this.search();
    },
    // 收款账号详情
    accountDetails(){
      this.$router.push('/user/payAccountList')
    },
    // 获取列表的数据
    initData(){
      dictionaryPayList(this.queryParams).then(res=>{
        if (res.data.code == 200) {
          res.data.data.map(item=>{
            item.editShow = true;
          })
          this.tableData = res.data.data;
          // 等待 DOM 同步后计算合并规则
          this.$nextTick(() => {
            this.getSpanArr(this.tableData);
          });
        }
      })
    },
    // 编辑
    editRow(row){
      this.tableData.map((item)=>{
        item.editShow = true;
      })
      row.editShow = false;
    },
    // 保存
    preservation(row){
      let params = {
        id:row.id,
        monthMaxMoney:row.monthMaxMoney,
        maxMoney:row.maxMoney,
        priority:row.priority
      }
      dictionaryPayUpdate(params).then(res=>{
        if (res.data.code == 200) {
          this.initData();
          // row.editShow = true
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //设置轮询
    handleStatusChange(row){
      let params = {id:row.id, status: row.status}
      dictionaryPayUpdateWxPayStatus(params).then(res=>{
        this.$notify({
          title: '成功',
          message: row.status == 0 ? '账号不参与轮询收款' : '账号参与轮询收款',
          type: 'success'
        });
        this.initData();
      }).catch(error => {
        this.$notify({
          title: '错误',
          message: '状态切换失败，请重试',
          type: 'error'
        });
        row.status = row.status === '1' ? '0' : '1';
      })
    },
    // 设置状态
    alonerenewChange(row){
      let params = {
        id:row.id,
        effect:row.effect
      }
      dictionaryPayUpdate(params).then(res=>{
        if (res.data.code == 200) {
          this.$message.success("状态更新成功");
          this.initData();
        }else{
          this.$message.error(res.data.message);
          // 回滚开关状态
          row.effect = row.effect === "1" ? "0" : "1";
          // this.initData();
        }
      })
    },
    // 获取相同编号的数组
    getOrderNumber() {
      let OrderObj = {}
      this.tableData.forEach((element, index) => {
        element.rowIndex = index
        if (OrderObj[element.name]) {
          OrderObj[element.name].push(index)
        } else {
          OrderObj[element.name] = []
          OrderObj[element.name].push(index)
        }
      });
      // 将数组长度大于1的值 存储到this.OrderIndexArr（也就是需要合并的项）
      for (let k in OrderObj){
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k]);
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        for (let i = 0; i < this.OrderIndexArr.length; i++) {
          let element = this.OrderIndexArr[i];
          for (let j = 0; j < element.length; j++) {
            let item = element[j]
            if (rowIndex == item) {
              if (j == 0) {
                return {
                  rowspan: element.length,
                  colspan: 1
                }
              }else{
                return {
                  rowspan :0,
                  colspan :0
                }
              }
            }
          }
        }
      }
    },
    getSpanArr(data) {　
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          // this.pos = 0
        } else {
        // 判断当前元素与上一个元素是否相同
          if (data[i].name === data[i - 1].name) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
  },
  created() {
    this.initData()
  },
};
</script>
<style scoped lang="less">

</style>


